import styled from "@emotion/styled";
import Button from "./button";

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
`;
